// extracted by mini-css-extract-plugin
export default {"Container":"PricingOverview_Container__8uhnr","Title":"PricingOverview_Title__Kadbg"};